import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { User } from 'src/app/models/user.model';
import { AuthService } from '../../services/auth-service/auth.service';
import { LocalStorageService } from '../../services/localStorage-service/local-storage.service';
import { UserLanguageService } from '../../services/user-language-service/user-language.service';
import { UserDashboardService } from '../../user-dashboard.service';
import {AdminLanguageService} from '../../services/admin-language-service/admin-language.service';
import {Router} from '@angular/router';

@Component({
    selector: 'app-successfull-completed-training',
    templateUrl: './successfull-completed-training.html',
    styleUrls: ['./successfull-completed-training.scss'],
    standalone: false
})
export class SuccessfullCompletedTraining implements OnInit {
  user: User
  userSub: Subscription;
  labels;
  labelsSub: Subscription;
  constructor(private router: Router, private localStorageService: LocalStorageService, private authService: AuthService, public dialogRef2: MatDialogRef<SuccessfullCompletedTraining>, public adminLanguageService: AdminLanguageService) { }

  ngOnInit(): void {
    this.labelsSub = this.adminLanguageService.labels$.subscribe((labels) => {
      this.labels = labels;
    })
  }
  onNoClick(){
    this.localStorageService.setItem('currentQuestionIndex', 0)
    this.localStorageService.setItem('questionScores', [])
    this.localStorageService.setItem('test', null)
    this.router.navigateByUrl('user/dashboard')
    setTimeout(() => {
      window.location.reload()
    }, 350)
    this.dialogRef2.close()
  }

}
